module.exports = __webpack_public_path__ + "static/media/patientnow.3bf6ed8e.svg";